import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const ACCESOS_CONST = 'accesos';
export const accesos_api = `${baseUrl}/${ACCESOS_CONST}`;

export const allAccesosService = async (params) => {
  try {
    const res = await axios.get(accesos_api, {
      headers: token({}),
      params,
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const oneAccesosService = async (id) => {
  try {
    const res = await axios.get(`${accesos_api}/${id}`, {
      headers: token({}),
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};
